import React, { useEffect, useState } from "react";
import loaderGif from "../../../../../../assets/images/loader.gif";
import { Tooltip } from "react-tooltip";
import "../Geo.css";

const GeoList = ({
  tableData,
  updateStatus,
  updateSegmentStatus,
  loader,
  onSort,
  sortingColumn,
  sortingOrder,
}) => {
  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="srno">Sr. No.</th>
              <th className="partner" onClick={() => onSort("ccode")}>
                Country Code{" "}
                {sortingColumn === "ccode" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i> // default up/down arrow icon
                )}
              </th>
              <th className="partner" onClick={() => onSort("name")}>
                Country Name{" "}
                {sortingColumn === "name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>
              <th onClick={() => onSort("status")}>
                Status{" "}
                {sortingColumn === "status" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>
              <th onClick={() => onSort("segment_status")}>
                Segment Status{" "}
                {sortingColumn === "segment_status" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>
            </tr>
          </thead>

          {!loader ? (
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData?.map((item, i) => (
                  <React.Fragment key={i}>
                    <tr>
                      <td className="srno">{i + 1}</td>
                      <td className="status" >
                        {item?.ccode?.trim() || "—"}
                      </td>
                      <td style={{ whiteSpace: "pre-line" }}>
                        {item?.name?.trim() || "—"}
                      </td>
                      <td className="text-center status">
                        <label className="custom-switch">
                          <input
                            type="checkbox"
                            checked={item?.status === 1}
                            onClick={() =>
                              updateStatus(
                                item.ccode,
                                item.status === 1 ? 0 : 1
                              )
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td className="text-center status">
                        <label className="custom-switch">
                          <input
                            type="checkbox"
                            checked={item?.segment_status === 1}
                            onClick={() =>
                              updateSegmentStatus(
                                item.ccode,
                                item.segment_status === 1 ? 0 : 1
                              )
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          ) : (
            <div className={`loader ${loader ? "show" : ""}`}>
              <label>
                <img src={loaderGif} alt="Loading..." />
              </label>
            </div>
          )}
        </table>
      </div>

      <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
    </>
  );
};

export default GeoList;
